// Generated by CoffeeScript 1.12.7
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('views/display_types/multiple',['require','underscore','./display_type','views/components/question_nav'],function(require) {
  var DisplayType, Multiple, QuestionNav, _;
  _ = require('underscore');
  DisplayType = require('./display_type');
  QuestionNav = require('views/components/question_nav');
  return Multiple = (function(superClass) {
    extend(Multiple, superClass);

    function Multiple() {
      this.windowScrollHandler = bind(this.windowScrollHandler, this);
      this.questionNavItemClickHandler = bind(this.questionNavItemClickHandler, this);
      this.submitButtonClickHandler = bind(this.submitButtonClickHandler, this);
      return Multiple.__super__.constructor.apply(this, arguments);
    }

    Multiple.prototype.questionNav = null;

    Multiple.prototype.questionViews = null;

    Multiple.prototype.initialize = function(options) {
      Multiple.__super__.initialize.call(this, options);
      return this.initListeners();
    };

    Multiple.prototype.render = function() {
      Multiple.__super__.render.call(this);
      this.questionNav = new QuestionNav({
        model: this.model
      });
      this.questionNav.on('select', this.questionNavItemClickHandler);
      $('#survey-container').append(this.questionNav.render());
      this.questionViews = [];
      this.model.get('questions').forEach((function(_this) {
        return function(question, index) {
          question = _this.initQuestion(question);
          _this.questionViews.push(question);
          return question.$el.hide().fadeIn();
        };
      })(this));
      return this.el;
    };

    Multiple.prototype.submitButtonClickHandler = function(e) {
      var invalidQuestion;
      e.preventDefault();
      invalidQuestion = _.find(this.questionViews, function(question) {
        return !question.valid;
      });
      if (invalidQuestion) {
        $(e.target).prop("disabled", false);
        return invalidQuestion.showValidationError();
      } else {
        $(e.target).prop("disabled", true);
        this.questionViews.forEach((function(_this) {
          return function(question) {
            _this.recordAnswer(question);
            return question.destroy();
          };
        })(this));
        if (this.questionNav) {
          return this.questionNav.destroy((function(_this) {
            return function() {
              _this.scrollTo(0);
              return _this.trigger('complete');
            };
          })(this));
        } else {
          return this.trigger('complete');
        }
      }
    };

    Multiple.prototype.scrollTo = function(yPos) {
      this.destroyListeners();
      return $('html, body').stop().delay(100).animate({
        scrollTop: yPos
      }, 500, (function(_this) {
        return function() {
          return _this.initListeners();
        };
      })(this));
    };

    Multiple.prototype.questionNavItemClickHandler = function(index) {
      var $question, pos;
      $question = this.$el.find(".question:nth-child(" + (index + 1) + ")");
      if ($question.length) {
        pos = $question.offset().top - $('#survey-header').outerHeight();
        return this.scrollTo(pos);
      }
    };

    Multiple.prototype.windowScrollHandler = function(e) {
      var currentQuestion, docTop, padding, top;
      padding = 100;
      if (this.questionNav) {
        docTop = $(window).scrollTop();
        top = $('#survey-header').outerHeight();
        currentQuestion = _.find(this.questionViews, (function(_this) {
          return function(question) {
            var yPos;
            yPos = question.$el.position().top - docTop;
            if ((yPos + padding > top && top > yPos - padding)) {
              return question;
            }
          };
        })(this));
        if (currentQuestion) {
          return this.questionNav.selectQuestionItem(currentQuestion.index);
        }
      }
    };

    Multiple.prototype.questionUpdateHandler = function(question) {
      return this.recordAnswer(question);
    };

    Multiple.prototype.initListeners = function() {
      return $(window).scroll(this.windowScrollHandler);
    };

    Multiple.prototype.destroyListeners = function() {
      return $(window).off('scroll', this.windowScrollHandler);
    };

    return Multiple;

  })(DisplayType);
});

